<template>
    <tr class="report__dashboard_show_coursecompletionoverview_table_item">
        <td class="report__dashboard_show_coursecompletionoverview_table_item_coursename">
            {{ itemCourseName }}
        </td>
        <td class="report__dashboard_show_coursecompletionoverview_table_item_enrolments">
            {{ itemEnrolments }}
        </td>
        <td class="report__dashboard_show_coursecompletionoverview_table_item_completions">
            {{ itemCompletions }}
        </td>
    </tr>
</template>

<script>

export default {
  name: 'report-dashboard-show-course-completion-overview-table-item',
  props: {
    item: {
      type: Object
    }
  },
  computed: {
    itemCourseName () {
      return this.item.name
    },
    itemEnrolments () {
      return this.item.active
    },
    itemCompletions () {
      return this.item.completed
    }
  }
}
</script>

<style lang="scss">
    @import "~@/assets/scss/components/ebs/reports/_reportdashboardcoursecompletionoverview.scss";
</style>
